import httpClient from './httpClient';

const newsService = {

    getNews(params){
        return httpClient.get('/api/wp-json/wp/v2/posts', {params:params})
    },
    getNewsImage(id) {
        return httpClient.get(`/api/wp-json/wp/v2/media/${id}`)

    }
}

export default newsService;